import {Button, Card, CardActionArea, CardActions, CardContent, CardMedia} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import SelectorContainer from "./SelectorContainer";
import {useCallback} from "react";

export const CurrentItemType = React.createContext();

export default function Cards(props) {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl)
    const currency=params.get('currency');
    const hotel=params.get('hotel');
    const [open, setOpen] = React.useState(false);
    const [warning, setWarning] = React.useState(false);

    const callbackOpen = useCallback((childData) => {
        setOpen(childData);
    });



    React.useEffect(() => {
        if (props.start == null) {
            setWarning(true);
        } else if (props.start > props.max) {
            setWarning(true);
        } else if (props.duration <= 0) {
            setWarning(true);
        } else {
            setWarning(false);
        }
    }, [props.start, props.duration, props.max, props.validDate]);

    // console.log("warning: " + warning);
    // console.log("props.validDate: "+ props.validDate);
    const setOpenCheck = (isopen, start, duration) => {
        var curDate = new Date();
        // console.log("+++ " + start + " , " + props.max +  " , "+ duration);
        // console.log("start > props.max: " + (start > props.max));
        if (start == null) {
            setWarning(true);
        } else if (start > props.max) {
            setWarning(true);
        } else if (duration <=0) {
            setWarning(true);
        } else {
            setWarning(false);
            setOpen(isopen);
        }

    }

    let blocked = false;
    if (props.blockoutinfo.includes(props.itemNo) || (!props.validDate)) {
        blocked = true;
    }



    return (
        <div style={{maxWidth: 300, margin: 20}}>
            <Card>
                <CardActionArea>
                <CardMedia
                    component="img"
                    sx={{minWidth:'100%'}}
                    image={"https://ozsnow.s3.ap-southeast-2.amazonaws.com"+props.source}
                />
                <CardContent>
                    <Typography variant="h5" component="div">
                        {props.name}
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                        Category: {props.itemCat}
                    </Typography>
                    {props.validDate?(<Typography variant="body1" color="textSecondary">
                        {props.duration} days : {" "+currency+" "+ props.prices[props.duration-1]}
                    </Typography>):null}
                </CardContent>
                <CardActions>
                    <Button size="small" variant={'contained'} disabled={blocked} color="primary" onClick={() => {
                        setOpenCheck(true, props.start, props.duration)
                    }}>Select</Button>
                    {(warning || !props.validDate)?<p style={{color: 'red'}}>Invalid Date!</p>:<div></div>}
                </CardActions>
                </CardActionArea>
            </Card>

            {
                open ?
                    <CurrentItemType.Provider
                        value={{currentItemType: props.name, currentItemName: props.itemCat, currentItemNo:props.itemNo, currentItemPrices: props.prices}}>
                        <SelectorContainer open={open} title={props.name + " " + props.itemCat} prices={props.prices}
                                           start={props.start} end={props.end} duration={props.duration} callbackOpen={callbackOpen} daterange={props.daterange}></SelectorContainer>
                    </CurrentItemType.Provider>
                    : <div></div>
            }

        </div>);

}